/**
 * Server-safe column ids + table display defaults for DEFAULT_USER_DISPLAY_PREFERENCES.
 * Keep in sync with ./columns.tsx.
 */

export const site_column_display_seeds: {
    id: string;
    defaultDisplayPreferences: {
        order: number;
        size: number;
        visible: boolean;
        pinned: boolean;
        displayAs: "number" | "string" | "date" | "other";
    };
}[] = [
    {
        id: "name",
        defaultDisplayPreferences: {
order: 1, size: 120, visible: true, displayAs: "string", pinned: true
        },
    },
    {
        id: "location",
        defaultDisplayPreferences: {
order: 2, size: 120, visible: true, displayAs: "string", pinned: true
        },
    },
    {
        id: "fullName",
        defaultDisplayPreferences: {
order: 3, size: 350, visible: true, displayAs: "string", pinned: false
        },
    },
    {
        id: "address",
        defaultDisplayPreferences: {
order: 4, size: 340, visible: true, displayAs: "string", pinned: false
        },
    },
    {
        id: "siteRoles",
        defaultDisplayPreferences: {
order: 5, size:400, visible: true, displayAs: "string", pinned: false
        },
    },
];
